module.exports = __webpack_public_path__ + "static/img/doctor3.bd2438ab.webp";